import { Api } from '../api';
import { register } from '../endpoints';
import type { RegisterFinalRequest, RegisterFirstRequest, RegisterFirstResponse, RegisterVerifyRequest } from './models';
import { AuthUtils } from '@shared/utils';

export class RegisterApi extends Api {
  static registerFirst = (request: RegisterFirstRequest) =>
    this.post<RegisterFirstRequest, RegisterFirstResponse>({ url: register.registerFirst(), data: request });

  static registerVerify = (request: RegisterVerifyRequest) => {
    const tempRegisterToken = AuthUtils.getRegisterTempToken();
    return this.post<RegisterVerifyRequest, RegisterFirstResponse>({
      url: register.registerVerify(),
      headers: { Authorization: `Bearer ${tempRegisterToken}` },
      data: request,
      responseErrorType: 'none',
    });
  };

  static registerFinal = (request: RegisterFinalRequest) => {
    const verifyTempToken = AuthUtils.getVerifyTempToken();
    return this.post<RegisterFinalRequest>({
      url: register.registerFinal(),
      headers: { Authorization: `Bearer ${verifyTempToken}` },
      data: request,
    });
  };

  static registerResendSms = () => this.post({ url: register.registerResendSms() });
}
